import React, { useState, useEffect } from "react";

const StartSmartFAQ = () => {
  const [openQuestions, setOpenQuestions] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  // ✅ Corrected useEffect (moved outside the function)
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 768);
    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // ✅ Fixed toggleQuestion function
  const toggleQuestion = (index) => {
    setOpenQuestions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="index-sec-1 pricing-page-faq">
      <div className="container">
        <h2
          className="font--31 color-293F  fw--400"
          style={{ justifyContent: "center", textAlign: "center" }}
        >
          Smart Start with NxaTel FAQs
        </h2>
        <div className="row">
          {/* Question 1 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">1</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(1)}
                    aria-expanded={openQuestions[1]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Do I need a SIM card or extra hardware?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[1] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    No. Smart Start is fully digital. Your business line works
                    through our app on your existing phone or laptop.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 2 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">2</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(2)}
                    aria-expanded={openQuestions[2]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I choose my own number?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[2] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes. You can select a local number from our South African or
                    African number pool when signing up.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 3 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">3</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(3)}
                    aria-expanded={openQuestions[3]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How long does it take to get started?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[3] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Just 3 minutes. Choose your number, sign up, and you’re
                    live. No delays or complicated setup.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          {/* Question 4 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">4</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(4)}
                    aria-expanded={openQuestions[4]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Is this a real business number or just a trial?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[4] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    It’s a real, professional business line with full features
                    like caller ID, SMS, and shared inbox. You can keep and use
                    it long-term.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 5 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="number-of-boxIndex">5</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(5)}
                    aria-expanded={openQuestions[5]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I use this number on multiple devices or with my team?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[5] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes. Your number works across devices, and you can assign
                    extensions or shared access for team members.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 6 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">6</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(6)}
                    aria-expanded={openQuestions[6]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What happens after the free start period?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[6] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    You can continue using your number at an affordable monthly
                    rate. We’ll remind you before billing starts, and there are
                    no contracts.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartSmartFAQ;
